module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/expose-loader?$!../~/jquery/dist/jquery.js
// module id = 695
// module chunks = 0